import { call, put, all, takeLatest } from "redux-saga/effects";
import { Api } from "../api";
import * as authActions from '../actions/auth'

function* login(action) {
  try {
    const { username, user } = action.payload;

    // if (!user) {

    //   const auth = yield call(Api.auth.login, {
    //     email: username,
    //     password,
    //     db: "SAQTest"
    //   });

    //   const { session_id } = auth.data.result;
    //   session = session_id;
    // }

    yield put({ type: authActions.AUTH_LOGIN_SUCCESS, payload: {user: user, username: username}});

  } catch (err) {
    yield put({ type: authActions.AUTH_LOGIN_FAIL });
  }
}

function* logout() {
  try {
    const username = sessionStorage.getItem("username");
    const token = sessionStorage.getItem("s_id");
    yield call(Api.auth.logOut, { username, token });
    // yield put({ type: authActions.AUTH_LOGOUT_SUCCESS });
    sessionStorage.removeItem("username");
    sessionStorage.removeItem("s_id");
    sessionStorage.removeItem("user");
    window.location.href = '/';
  } catch (err) {
    sessionStorage.removeItem("username");
    sessionStorage.removeItem("s_id");
    sessionStorage.removeItem("user");
    yield put({ type: authActions.AUTH_LOGOUT_FAIL })
  }
}

function* authAmanah(action) {
  try {
    const res = yield call(Api.auth.authAmanah, action.payload);
    const {token, userName} = res.data;
    const data = { user: { ...res.data, session_id: token }, username: userName}
    yield put({ type: authActions.AUTH_AMANAH_SUCCESS, payload: data});
    sessionStorage.setItem('username', userName);
    sessionStorage.setItem('s_id', token);
    sessionStorage.setItem('user', JSON.stringify({ ...res.data, session_id: token }));
    action.navigate('/mashhad/landing', { replace: true });
  } catch (err) {
    sessionStorage.removeItem('username');
    sessionStorage.removeItem('s_id');
    sessionStorage.removeItem('user');
    yield put({ type: authActions.AUTH_AMANAH_FAIL, payload: { error: err.response.data.message }});
    action.navigate('/', { replace: true })
  }
}

function* forgotPassword(action) {
  try {
    const res = yield call(Api.auth.forgetPassword, action.payload);
    yield put({ 
      type: authActions.FORGOT_PASSWORD_SUCCESS, 
      payload: { message: res.data.message }
    });
  } catch (err) {
    yield put({ 
      type: authActions.FORGOT_PASSWORD_FAIL, 
      payload: { error: err?.response?.data?.message || 'Failed to send reset email' }
    });
  }
}

function* verifyResetCode(action) {
  try {
    const res = yield call(Api.auth.verifyResetCode, action.payload);
    yield put({ 
      type: authActions.VERIFY_RESET_CODE_SUCCESS, 
      payload: { valid: res.data.valid }
    });
  } catch (err) {
    yield put({ 
      type: authActions.VERIFY_RESET_CODE_FAIL, 
      payload: { error: err?.response?.data?.message || 'Invalid or expired code' }
    });
  }
}

function* resetPassword(action) {
  try {
    const res = yield call(Api.auth.resetPassword, action.payload);
    yield put({ 
      type: authActions.RESET_PASSWORD_SUCCESS, 
      payload: { message: res.data.message }
    });
  } catch (err) {
    yield put({ 
      type: authActions.RESET_PASSWORD_FAIL, 
      payload: { error: err?.response?.data?.message || 'Failed to reset password' }
    });
  }
}

export default all([
  takeLatest(authActions.AUTH_LOGIN_REQUEST, login),
  takeLatest(authActions.AUTH_LOGOUT_REQUEST, logout),
  takeLatest(authActions.AUTH_AMANAH_REQUEST, authAmanah),
  takeLatest(authActions.FORGOT_PASSWORD_REQUEST, forgotPassword),
  takeLatest(authActions.VERIFY_RESET_CODE_REQUEST, verifyResetCode),
  takeLatest(authActions.RESET_PASSWORD_REQUEST, resetPassword),
])